import { AdvancingActivityLog } from "advancing/activity/AdvancingActivityLog";
import { getApproveActivitySource } from "advancingapprove/utils";
import React from "react";
import { useLoaderData } from "react-router";

export const ActivityTab = () => {
  const { advancingSession } = useLoaderData<server.viewmodel.AdvancingApproveFrontModel>();

  return <AdvancingActivityLog source={getApproveActivitySource(advancingSession.advancingSessionId)} />;
};
